import React, { useState } from 'react';
import { acknowledgeNotice, resolveEffectChoice } from '../api/cardChanges';
import './CardChangeNoticeModal.css';

function CardChangeNoticeModal({ notices, onDone }) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [resolving, setResolving] = useState(false);

  if (!notices || notices.length === 0) return null;

  const notice = notices[currentIdx];
  if (!notice) return null;

  const advance = () => {
    if (currentIdx + 1 < notices.length) {
      setCurrentIdx(currentIdx + 1);
    } else {
      onDone();
    }
  };

  const handleAcknowledge = async () => {
    setResolving(true);
    try {
      await acknowledgeNotice(notice._id);
    } catch (err) {
      console.warn('Failed to acknowledge notice:', err);
    }
    setResolving(false);
    advance();
  };

  const handleEffectChoice = async (choice) => {
    setResolving(true);
    try {
      await resolveEffectChoice(notice._id, choice);
    } catch (err) {
      console.warn('Failed to resolve effect choice:', err);
    }
    setResolving(false);
    advance();
  };

  return (
    <div className="ccn-overlay">
      <div className="ccn-modal">
        <div className="ccn-counter">
          {notices.length > 1 && (
            <span className="ccn-counter-text">{currentIdx + 1} / {notices.length}</span>
          )}
        </div>

        {notice.type === 'refund' && (
          <div className="ccn-content">
            <div className="ccn-icon ccn-icon-refund">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M16 8h-6a2 2 0 100 4h4a2 2 0 110 4H8" />
                <path d="M12 18V6" />
              </svg>
            </div>
            <h2 className="ccn-title">Price Adjustment Refund</h2>
            <p className="ccn-desc">
              The cost of <strong>{notice.drug_name}</strong> has been reduced
              from <span className="ccn-old-price">${notice.old_price}</span> to{' '}
              <span className="ccn-new-price">${notice.new_price}</span>.
            </p>
            <div className="ccn-refund-amount">
              +${notice.refund_amount} credited to your balance
            </div>
            <button
              className="ccn-btn ccn-btn-primary"
              onClick={handleAcknowledge}
              disabled={resolving}
            >
              {resolving ? 'Saving...' : 'Got it'}
            </button>
          </div>
        )}

        {notice.type === 'effect_choice' && (
          <div className="ccn-content">
            <div className="ccn-icon ccn-icon-swap">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="17 1 21 5 17 9" />
                <path d="M3 11V9a4 4 0 014-4h14" />
                <polyline points="7 23 3 19 7 15" />
                <path d="M21 13v2a4 4 0 01-4 4H3" />
              </svg>
            </div>
            <h2 className="ccn-title">Card Effect Changed</h2>
            <p className="ccn-desc">
              The effect on <strong>{notice.owned_drug_name}</strong> has changed
              from <em>{notice.original_effect_name}</em> to <em>{notice.new_effect_name}</em>.
            </p>
            <p className="ccn-desc ccn-desc-sub">
              <strong>{notice.other_drug_name}</strong> now carries
              the <em>{notice.original_effect_name}</em> effect.
            </p>
            <p className="ccn-desc ccn-desc-prompt">Choose one:</p>

            <div className="ccn-choices">
              <button
                className="ccn-choice-btn ccn-choice-keep"
                onClick={() => handleEffectChoice('keep_drug')}
                disabled={resolving}
              >
                <span className="ccn-choice-label">Keep {notice.owned_drug_name}</span>
                <span className="ccn-choice-detail">Now with {notice.new_effect_name}</span>
              </button>
              <span className="ccn-choice-or">or</span>
              <button
                className="ccn-choice-btn ccn-choice-swap"
                onClick={() => handleEffectChoice('keep_effect')}
                disabled={resolving}
              >
                <span className="ccn-choice-label">Swap to {notice.other_drug_name}</span>
                <span className="ccn-choice-detail">Keeps {notice.original_effect_name}</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CardChangeNoticeModal;
